module.exports = __webpack_public_path__ + "img/vwid2.1a9da56a.webp";